module.exports = __webpack_public_path__ + "img/refresh_white.a948fca7.svg";